// extracted by mini-css-extract-plugin
module.exports = {"small":"SmallCard_small__iscdy","initials":"SmallCard_initials__XqRDS"};